import { Box, styled } from "@washingtonpost/wpds-ui-kit";
import { generateGradient } from "../../common/utils";

export const ControlsWrapper = styled("div", {
  width: "100%",
  height: "100%",
  background: generateGradient({ topPercent: 15, bottomPercent: 25 }),
  variants: {
    isVisible: {
      true: {
        opacity: 1
      },
      false: {
        opacity: 0
      }
    }
  }
});

export const TopControlsWrapper = styled("div", {
  boxSizing: "border-box",
  position: "absolute",
  top: "0",
  width: "100%",
  paddingTop: "$075",
  paddingLeft: "$150",
  paddingRight: "$150",
  variants: {
    isMiniPlayer: {
      true: {
        paddingTop: "$050"
      }
    }
  }
});

export const StyledTopControls = styled("div", {
  justifyContent: "space-between",
  flexDirection: "row",
  width: "100%",
  display: "flex",
  "@sm": {
    alignItems: "center"
  }
});

export const BottomControlsWrapper = styled("div", {
  boxSizing: "border-box",
  position: "absolute",
  bottom: "0%",
  width: "100%",
  paddingBottom: "$075",
  paddingLeft: "$150",
  paddingRight: "$150",
  variants: {
    isMiniPlayer: {
      true: {
        paddingBottom: "$050"
      }
    },
    isCarousel: {
      true: {
        "@sm": {
          marginBottom: "$150"
        }
      },
      false: {
        "@sm": {
          marginBottom: "0"
        }
      }
    },
    isVertical: {
      true: {},
      false: {}
    }
  },
  compoundVariants: [
    {
      // Landscape carousel players are short; skip extra bottom offset.
      isCarousel: true,
      isVertical: false,
      css: {
        "@sm": {
          marginBottom: "0"
        }
      }
    }
  ],
  defaultVariants: {
    isVertical: true
  }
});

export const BottomControls = styled("div", {
  display: "grid",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  variants: {
    isLooping: {
      true: {
        gridTemplateColumns: "repeat(2, 1fr)"
      },
      false: {
        gridTemplateColumns: "repeat(3, 1fr)"
      }
    }
  }
});

export const LeftButtonsWrapper = styled("div", {
  display: "flex"
});

export const LiveWrapper = styled("div", {
  alignItems: "center",
  display: "flex",
  gap: "$025",
  paddingRight: "$100"
});

export const LiveText = styled("div", {
  color: "$secondary",
  fontWeight: "$bold"
});

export const RedDot = styled("span", {
  height: "$050",
  width: "$050",
  backgroundColor: "$red100",
  borderRadius: "50%",
  display: "inline-block",
  animation: "sc-status-light-blink-animation 4s ease-in-out infinite alternate"
});

export const PlayPauseWrapper = styled(Box, {
  variants: {
    isLooping: {
      true: {
        justifySelf: "left"
      },
      false: {
        justifySelf: "center"
      }
    }
  }
});
